import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isLoading", "children", "href", "onClick", "templateId", "className", "disabled", "$buttonType"],
    _excluded2 = ["theme", "$styles", "isLoading", "$withArrow", "$buttonType", "$size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import convertLayoutProps from '../../utils/convertLayoutProps';
import FocusTrap from '../focus-trap/FocusTrap';
import Box from '../layout/Box';
import { useTemplateOpener } from '../template-opener/TemplateOpener';
import getArrowDirectionCSS from './helpers/getArrowDirectionCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SpinnerBase = function SpinnerBase(_ref) {
  var _ref$$size = _ref.$size,
      $size = _ref$$size === void 0 ? 24 : _ref$$size,
      _ref$$gutter = _ref.$gutter,
      $gutter = _ref$$gutter === void 0 ? 4 : _ref$$gutter,
      className = _ref.className;
  return /*#__PURE__*/_jsx(Box, {
    className: className,
    $styles: {
      width: $size,
      height: $size
    },
    children: /*#__PURE__*/_jsxs("svg", {
      viewBox: "0 0 ".concat($size, " ").concat($size),
      children: [/*#__PURE__*/_jsx("title", {
        children: "Loading..."
      }), /*#__PURE__*/_jsx("circle", {
        cx: $size / 2,
        cy: $size / 2,
        r: $size / 2 - $gutter / 2
      })]
    })
  });
};

var spinner = function spinner(size) {
  return keyframes(["0%{stroke-dashoffset:", ";transform:rotate(0deg);}50%{stroke-dashoffset:", ";transform:rotate(720deg);}100%{stroke-dashoffset:", ";transform:rotate(1080deg);}"], 0.66 * size, 3.14 * size, 0.66 * size);
};

var RotatingSpinner = styled(SpinnerBase).withConfig({
  displayName: "Button__RotatingSpinner",
  componentId: "sc-15mxbna-0"
})(["svg{x:0px;y:0px;", "}"], function (_ref2) {
  var theme = _ref2.theme,
      _ref2$$size = _ref2.$size,
      $size = _ref2$$size === void 0 ? 24 : _ref2$$size;
  return css(["", " circle{fill:transparent;stroke:currentColor;stroke-width:2;stroke-linecap:round;transform-origin:center;animation:", " 2s linear infinite;stroke-dasharray:", ";}"], theme.normalizeStyles({
    width: $size,
    height: $size
  }), spinner($size), 3.14 * $size);
});
var Hidden = styled.div.withConfig({
  displayName: "Button__Hidden",
  componentId: "sc-15mxbna-1"
})(["visibility:hidden;display:inherit;"]); //! missing rel, event_class, target from twig

var ButtonElement = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var _ref3$isLoading = _ref3.isLoading,
      isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading,
      children = _ref3.children,
      href = _ref3.href,
      _onClick = _ref3.onClick,
      templateId = _ref3.templateId,
      className = _ref3.className,
      disabled = _ref3.disabled,
      $buttonType = _ref3.$buttonType,
      props = _objectWithoutProperties(_ref3, _excluded);

  var _useTemplateOpener = useTemplateOpener(),
      setTemplateId = _useTemplateOpener.setTemplateId;

  if (isLoading) {
    return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
      className: className,
      disabled: true,
      ref: ref
    }, props), {}, {
      children: /*#__PURE__*/_jsxs(FocusTrap, {
        children: [/*#__PURE__*/_jsx(RotatingSpinner, {}), /*#__PURE__*/_jsx(Hidden, {
          children: children
        })]
      })
    }));
  }

  if (href) {
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      onClick: function onClick(e) {
        if (disabled) {
          e.preventDefault();
          return;
        }

        if (templateId) {
          e.preventDefault();
          setTemplateId(templateId);
        }

        if (_onClick) {
          _onClick(e);
        }
      },
      ref: ref,
      href: href,
      className: "".concat(className, " js__event-link")
    }, props), {}, {
      children: /*#__PURE__*/_jsx(FocusTrap, {
        children: children
      })
    }));
  }

  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    onClick: function onClick(e) {
      if (templateId) {
        e.preventDefault();
        setTemplateId(templateId);
      }

      if (_onClick) {
        _onClick(e);
      }
    },
    ref: ref,
    className: className,
    disabled: disabled
  }, props), {}, {
    children: /*#__PURE__*/_jsx(FocusTrap, {
      children: children
    })
  }));
});
ButtonElement.displayName = 'ButtonElement';
var ButtonBase = styled(ButtonElement).withConfig({
  displayName: "Button__ButtonBase",
  componentId: "sc-15mxbna-2"
})(["display:inline-block;padding:0;transition:background ", ",border-color ", ";font-family:", ";text-decoration:none;appearance:none;background-color:transparent;border:none;outline:none;cursor:pointer;white-space:nowrap;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.animation.transitionDuration;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.animation.transitionDuration;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.formular;
});
var Button = styled(ButtonBase).withConfig({
  displayName: "Button",
  componentId: "sc-15mxbna-3"
})(["", " ", " ", "{position:relative;", "}", "{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}", ""], function (_ref7) {
  var theme = _ref7.theme,
      $buttonType = _ref7.$buttonType;
  return $buttonType && theme.expandVariants($buttonType, theme.buttons.variants);
}, function (_ref8) {
  var theme = _ref8.theme,
      $styles = _ref8.$styles,
      isLoading = _ref8.isLoading,
      $withArrow = _ref8.$withArrow,
      $buttonType = _ref8.$buttonType,
      $size = _ref8.$size,
      props = _objectWithoutProperties(_ref8, _excluded2);

  var buttonSize = $size ? theme.buttons.sizes[$size] : {};
  return theme.normalizeStyles(_objectSpread(_objectSpread(_objectSpread({}, buttonSize), convertLayoutProps(props)), $styles));
}, FocusTrap, function (_ref9) {
  var theme = _ref9.theme,
      $size = _ref9.$size,
      $withArrow = _ref9.$withArrow;
  var buttonSpacing = {};

  if ($size) {
    buttonSpacing = $withArrow ? theme.buttons.withArrowSpacing[$size] : theme.buttons.spacing[$size];
  }

  return theme.normalizeStyles(buttonSpacing);
}, RotatingSpinner, getArrowDirectionCSS);
export default Button;